import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { SemanticResolvedLink } from '@/lib/semantic-content/types';

export default function RelatedLinksSection({
  title,
  description,
  links,
}: {
  title: string;
  description?: string;
  links: SemanticResolvedLink[];
}) {
  return (
    <section aria-labelledby={title.replace(/\s+/g, '-').toLowerCase()}>
      <Card className="border-border/60 bg-card/60 shadow-none">
        <CardHeader>
          <CardTitle id={title.replace(/\s+/g, '-').toLowerCase()} className="text-2xl">
            {title}
          </CardTitle>
          {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
        </CardHeader>
        <CardContent>
          <ul className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
            {links.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="group block rounded-xl border border-border/60 bg-background/80 p-4 transition-colors hover:border-primary/40 hover:bg-primary/5"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <div className="font-semibold text-foreground">{link.label}</div>
                      {link.description ? <p className="mt-2 text-sm leading-6 text-muted-foreground">{link.description}</p> : null}
                    </div>
                    <ArrowRight className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-1 group-hover:text-primary" />
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </section>
  );
}
